export default class InfoProductInterector {

  constructor(service) {
    this.service = service
  }

  getData() {
    return this.service.getData();
  }
}